import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import {initAccount, loadCompanyInfo} from './backend'
import { getUserId } from './utils'
import { forceDestroy } from './messaging'

(async () => {
  try {
    const companyInfo = await loadCompanyInfo()
    if (!companyInfo) {
      forceDestroy()
      throw new Error('无法获取companyInfo')
    }
    const account = await initAccount(getUserId())
    if (!account) {
      forceDestroy()
      throw new Error('无法获取account')
    }
    ReactDOM.render(
      <React.StrictMode>
        <App companyInfo={companyInfo} visitor={account} />
      </React.StrictMode>,
      document.getElementById('marketup_chat')
    );
  } catch (e) {
    console.log(e)
  }
})()
